import { Link } from "react-router-dom";
import type { Media } from "@/types/media";
import { formatHeat } from "@/utils/media";

interface MediaCardProps {
  media: Media;
  compact?: boolean;
}

export default function MediaCard({ media, compact = false }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${media.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-200" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={media.poster}
          alt={`${media.title}海报`}
          title={`${media.title} - ${media.genres.join(" ")}在线观看`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded bg-accent-500 px-1.5 py-0.5 text-xs font-bold text-primary-950">
          {media.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded bg-primary-950/70 px-1.5 py-0.5 text-xs text-background-50">
          <i className="ri-fire-line text-accent-400" />
          {formatHeat(media.heat)}
        </span>
        <span className="absolute inset-x-0 bottom-0 flex items-center justify-center bg-gradient-to-t from-primary-950/80 to-transparent py-2 text-xs font-medium text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
          <i className="ri-play-circle-line mr-1" />
          查看详情
        </span>
      </div>
      <div className={compact ? "p-2" : "p-2.5 md:p-3"}>
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
          {media.title}
        </h3>
        <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
          <span>{media.year}</span>
          <span className="text-background-400">·</span>
          <span>{media.region}</span>
        </p>
        {!compact && (
          <div className="mt-2 flex flex-wrap gap-1">
            {media.genres.slice(0, 2).map((genre) => (
              <span
                key={genre}
                className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800"
              >
                {genre}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}